/* © ИП Коробкин И.Н., KIN DIGITAL CRM+ */
export const fmtMoney = (v: string | number | null | undefined) => {
  if (v === null || v === undefined || v === '') return '-';
  const n = typeof v === 'string' ? Number(v) : v;
  return new Intl.NumberFormat('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n) + '\u00a0₽';
};
export const fmtDate = (v: string | Date | null | undefined) => {
  if (!v) return '-';
  const d = typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v) ? new Date(v + 'T00:00:00') : new Date(v);
  return d.toLocaleDateString('ru-RU');
};
export const fmtDateTime = (v: string | Date | null | undefined) => (v ? new Date(v).toLocaleString('ru-RU', { dateStyle: 'short', timeStyle: 'short' }) : '-');
export const fmtSize = (b?: number | null) => (!b ? '' : b < 1024 ? `${b} Б` : b < 1048576 ? `${(b / 1024).toFixed(0)} КБ` : `${(b / 1048576).toFixed(1)} МБ`);
export const today = () => new Date().toISOString().slice(0, 10);
/** Значение для <input type="datetime-local"> -> ISO со смещением часового пояса */
export const localToIso = (v: string) => (v ? new Date(v).toISOString() : null);
export const isoToLocal = (v?: string | null) => {
  if (!v) return '';
  const d = new Date(v);
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};
